import {createContext} from "react";

export const BranchContext = createContext({
    branches: [],
    setBranches: () => {
    }
});
